import React from 'react';

const VSvgMailIcon = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
            <path d="M8.01207 8.71487C8.25966 8.71487 8.48913 8.59724 8.75483 8.32485L14.0084 2.99461C13.785 2.77175 13.3684 2.6665 12.7705 2.6665H3.0483C2.54106 2.6665 2.18478 2.76556 1.9855 2.96985L7.26932 8.32485C7.52898 8.59105 7.75845 8.71487 8.01207 8.71487ZM1.48429 12.3365L5.75362 8.00912L1.47222 3.68179C1.38164 3.85513 1.33333 4.15228 1.33333 4.57945V11.414C1.33333 11.8536 1.38164 12.1631 1.48429 12.3365ZM14.5217 12.3303C14.6184 12.1507 14.6667 11.8474 14.6667 11.414V4.57945C14.6667 4.16467 14.6184 3.86751 14.5338 3.70036L10.2645 8.00912L14.5217 12.3303ZM3.22946 13.3332H12.9517C13.4589 13.3332 13.8092 13.2341 14.0084 13.036L9.65458 8.61582L9.25603 9.0306C8.83937 9.43919 8.44685 9.62491 8.01207 9.62491C7.57125 9.62491 7.17874 9.43919 6.76811 9.0306L6.36352 8.61582L2.02173 13.0298C2.2512 13.2341 2.64975 13.3332 3.22946 13.3332Z" fill="currentColor" />
        </svg>
    )
}

export default VSvgMailIcon;

